/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ActiveTask,
  ApiError,
  AuditLogResponse,
  ChangeRole,
  GetUserAuditLogsParams,
  GetUserLoginHistoryParams,
  ListUsersParams,
  LoginHistoryResponse,
  UpdateEmail,
  UpdateTechnicianFields,
  UpdateUserPermissions,
  UserDetailResponse,
  UserListResponse,
  UserWithPermissions,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getRecordLoginEventUrl = () => {
  return `/users/me/login-event`;
};

/**
 * Records a login event for the current user with IP and user-agent metadata.
 * @summary Record login event
 */
export const recordLoginEvent = async (options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getRecordLoginEventUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getRecordLoginEventMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof recordLoginEvent>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof recordLoginEvent>>, TError, void, TContext> => {
  const mutationKey = ['recordLoginEvent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordLoginEvent>>, void> = () => {
    return recordLoginEvent(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordLoginEventMutationResult = NonNullable<Awaited<ReturnType<typeof recordLoginEvent>>>;

export type RecordLoginEventMutationError = ApiError;

/**
 * @summary Record login event
 */
export const useRecordLoginEvent = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof recordLoginEvent>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof recordLoginEvent>>, TError, void, TContext> => {
  return useMutation(getRecordLoginEventMutationOptions(options), queryClient);
};
export const getGetActiveTaskUrl = () => {
  return `/users/me/active-task`;
};

/**
 * @summary Get the current user's active labor task
 */
export const getActiveTask = async (options?: RequestInit): Promise<ActiveTask | null> => {
  return apiFetcher<ActiveTask | null>(getGetActiveTaskUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetActiveTaskQueryKey = () => {
  return [`/users/me/active-task`] as const;
};

export const getGetActiveTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveTask>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTask>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveTaskQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveTask>>> = ({ signal }) =>
    getActiveTask({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveTask>>>;
export type GetActiveTaskQueryError = ApiError;

export function useGetActiveTask<TData = Awaited<ReturnType<typeof getActiveTask>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTask>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveTask>>,
          TError,
          Awaited<ReturnType<typeof getActiveTask>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveTask<TData = Awaited<ReturnType<typeof getActiveTask>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTask>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveTask>>,
          TError,
          Awaited<ReturnType<typeof getActiveTask>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveTask<TData = Awaited<ReturnType<typeof getActiveTask>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTask>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current user's active labor task
 */

export function useGetActiveTask<TData = Awaited<ReturnType<typeof getActiveTask>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTask>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveTaskQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListUsersUrl = (params?: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/users?${stringifiedParams}` : `/users`;
};

/**
 * Returns all users associated with the current shop. Optionally filter by role.
 * @summary List users
 */
export const listUsers = async (params?: ListUsersParams, options?: RequestInit): Promise<UserListResponse> => {
  return apiFetcher<UserListResponse>(getListUsersUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) =>
    listUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>;
export type ListUsersQueryError = ApiError;

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
  params: undefined | ListUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof listUsers>>, TError, Awaited<ReturnType<typeof listUsers>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetUserUrl = (id: string) => {
  return `/users/${id}`;
};

/**
 * Returns detailed information about a specific user, including last login activity.
 * @summary Get user detail
 */
export const getUser = async (id: string, options?: RequestInit): Promise<UserDetailResponse> => {
  return apiFetcher<UserDetailResponse>(getGetUserUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetUserQueryKey = (id: string) => {
  return [`/users/${id}`] as const;
};

export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) =>
    getUser(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>;
export type GetUserQueryError = ApiError;

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getUser>>, TError, Awaited<ReturnType<typeof getUser>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUser>>, TError, Awaited<ReturnType<typeof getUser>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user detail
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteUserUrl = (id: string) => {
  return `/users/${id}`;
};

/**
 * Deletes a user profile and all related data (cascades to user_roles, etc.)
 * @summary Delete a user
 */
export const deleteUser = async (id: string, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getDeleteUserUrl(id), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteUserMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError, { id: string }, TContext> => {
  const mutationKey = ['deleteUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return deleteUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>;

export type DeleteUserMutationError = ApiError;

/**
 * @summary Delete a user
 */
export const useDeleteUser = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError, { id: string }, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteUser>>, TError, { id: string }, TContext> => {
  return useMutation(getDeleteUserMutationOptions(options), queryClient);
};
export const getUpdateUserPermissionsUrl = (id: string) => {
  return `/users/${id}/permissions`;
};

/**
 * @summary Update user permissions
 */
export const updateUserPermissions = async (
  id: string,
  updateUserPermissions?: UpdateUserPermissions,
  options?: RequestInit
): Promise<void> => {
  return apiFetcher<void>(getUpdateUserPermissionsUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserPermissions),
  });
};

export const getUpdateUserPermissionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPermissions>>,
    TError,
    { id: string; data?: UpdateUserPermissions },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserPermissions>>,
  TError,
  { id: string; data?: UpdateUserPermissions },
  TContext
> => {
  const mutationKey = ['updateUserPermissions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserPermissions>>,
    { id: string; data?: UpdateUserPermissions }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserPermissions(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPermissions>>>;
export type UpdateUserPermissionsMutationBody = UpdateUserPermissions | undefined;
export type UpdateUserPermissionsMutationError = unknown;

/**
 * @summary Update user permissions
 */
export const useUpdateUserPermissions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserPermissions>>,
      TError,
      { id: string; data?: UpdateUserPermissions },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserPermissions>>,
  TError,
  { id: string; data?: UpdateUserPermissions },
  TContext
> => {
  return useMutation(getUpdateUserPermissionsMutationOptions(options), queryClient);
};
export const getChangeUserRoleUrl = (id: string) => {
  return `/users/${id}/role`;
};

/**
 * Changes the user role and resets all permission overrides to the new role defaults
 * @summary Change user role
 */
export const changeUserRole = async (id: string, changeRole?: ChangeRole, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getChangeUserRoleUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeRole),
  });
};

export const getChangeUserRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserRole>>,
    TError,
    { id: string; data?: ChangeRole },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserRole>>,
  TError,
  { id: string; data?: ChangeRole },
  TContext
> => {
  const mutationKey = ['changeUserRole'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserRole>>, { id: string; data?: ChangeRole }> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return changeUserRole(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserRole>>>;
export type ChangeUserRoleMutationBody = ChangeRole | undefined;
export type ChangeUserRoleMutationError = unknown;

/**
 * @summary Change user role
 */
export const useChangeUserRole = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeUserRole>>,
      TError,
      { id: string; data?: ChangeRole },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof changeUserRole>>,
  TError,
  { id: string; data?: ChangeRole },
  TContext
> => {
  return useMutation(getChangeUserRoleMutationOptions(options), queryClient);
};
export const getUpdateUserTechnicianUrl = (id: string) => {
  return `/users/${id}/technician`;
};

/**
 * Updates technician-specific fields (color, isActive) for a user with technician role
 * @summary Update technician fields
 */
export const updateUserTechnician = async (
  id: string,
  updateTechnicianFields?: UpdateTechnicianFields,
  options?: RequestInit
): Promise<UserWithPermissions> => {
  return apiFetcher<UserWithPermissions>(getUpdateUserTechnicianUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTechnicianFields),
  });
};

export const getUpdateUserTechnicianMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserTechnician>>,
    TError,
    { id: string; data?: UpdateTechnicianFields },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserTechnician>>,
  TError,
  { id: string; data?: UpdateTechnicianFields },
  TContext
> => {
  const mutationKey = ['updateUserTechnician'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserTechnician>>,
    { id: string; data?: UpdateTechnicianFields }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserTechnician(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserTechnicianMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserTechnician>>>;
export type UpdateUserTechnicianMutationBody = UpdateTechnicianFields | undefined;
export type UpdateUserTechnicianMutationError = ApiError;

/**
 * @summary Update technician fields
 */
export const useUpdateUserTechnician = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserTechnician>>,
      TError,
      { id: string; data?: UpdateTechnicianFields },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserTechnician>>,
  TError,
  { id: string; data?: UpdateTechnicianFields },
  TContext
> => {
  return useMutation(getUpdateUserTechnicianMutationOptions(options), queryClient);
};
export const getGetUserAuditLogsUrl = (id: string, params?: GetUserAuditLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/users/${id}/audit-logs?${stringifiedParams}` : `/users/${id}/audit-logs`;
};

/**
 * Returns paginated audit log entries for actions performed by a specific user.
 * @summary Get user audit logs
 */
export const getUserAuditLogs = async (
  id: string,
  params?: GetUserAuditLogsParams,
  options?: RequestInit
): Promise<AuditLogResponse> => {
  return apiFetcher<AuditLogResponse>(getGetUserAuditLogsUrl(id, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetUserAuditLogsQueryKey = (id: string, params?: GetUserAuditLogsParams) => {
  return [`/users/${id}/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getGetUserAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAuditLogs>>,
  TError = ApiError,
>(
  id: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserAuditLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAuditLogs>>> = ({ signal }) =>
    getUserAuditLogs(id, params, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAuditLogs>>>;
export type GetUserAuditLogsQueryError = ApiError;

export function useGetUserAuditLogs<TData = Awaited<ReturnType<typeof getUserAuditLogs>>, TError = ApiError>(
  id: string,
  params: undefined | GetUserAuditLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getUserAuditLogs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAuditLogs<TData = Awaited<ReturnType<typeof getUserAuditLogs>>, TError = ApiError>(
  id: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getUserAuditLogs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAuditLogs<TData = Awaited<ReturnType<typeof getUserAuditLogs>>, TError = ApiError>(
  id: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user audit logs
 */

export function useGetUserAuditLogs<TData = Awaited<ReturnType<typeof getUserAuditLogs>>, TError = ApiError>(
  id: string,
  params?: GetUserAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuditLogs>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserAuditLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetUserLoginHistoryUrl = (id: string, params?: GetUserLoginHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/users/${id}/login-history?${stringifiedParams}`
    : `/users/${id}/login-history`;
};

/**
 * Returns paginated login history entries for a specific user.
 * @summary Get user login history
 */
export const getUserLoginHistory = async (
  id: string,
  params?: GetUserLoginHistoryParams,
  options?: RequestInit
): Promise<LoginHistoryResponse> => {
  return apiFetcher<LoginHistoryResponse>(getGetUserLoginHistoryUrl(id, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetUserLoginHistoryQueryKey = (id: string, params?: GetUserLoginHistoryParams) => {
  return [`/users/${id}/login-history`, ...(params ? [params] : [])] as const;
};

export const getGetUserLoginHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserLoginHistory>>,
  TError = ApiError,
>(
  id: string,
  params?: GetUserLoginHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLoginHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserLoginHistoryQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLoginHistory>>> = ({ signal }) =>
    getUserLoginHistory(id, params, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserLoginHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserLoginHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLoginHistory>>>;
export type GetUserLoginHistoryQueryError = ApiError;

export function useGetUserLoginHistory<TData = Awaited<ReturnType<typeof getUserLoginHistory>>, TError = ApiError>(
  id: string,
  params: undefined | GetUserLoginHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLoginHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLoginHistory>>,
          TError,
          Awaited<ReturnType<typeof getUserLoginHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserLoginHistory<TData = Awaited<ReturnType<typeof getUserLoginHistory>>, TError = ApiError>(
  id: string,
  params?: GetUserLoginHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLoginHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLoginHistory>>,
          TError,
          Awaited<ReturnType<typeof getUserLoginHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserLoginHistory<TData = Awaited<ReturnType<typeof getUserLoginHistory>>, TError = ApiError>(
  id: string,
  params?: GetUserLoginHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLoginHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user login history
 */

export function useGetUserLoginHistory<TData = Awaited<ReturnType<typeof getUserLoginHistory>>, TError = ApiError>(
  id: string,
  params?: GetUserLoginHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLoginHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserLoginHistoryQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getResetUserPasswordUrl = (id: string) => {
  return `/users/${id}/reset-password`;
};

/**
 * Sends a password reset email to the target user. Only admins can trigger this.
 * @summary Trigger password reset for a user
 */
export const resetUserPassword = async (id: string, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getResetUserPasswordUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getResetUserPasswordMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError, { id: string }, TContext> => {
  const mutationKey = ['resetUserPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return resetUserPassword(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>;

export type ResetUserPasswordMutationError = ApiError;

/**
 * @summary Trigger password reset for a user
 */
export const useResetUserPassword = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError, { id: string }, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof resetUserPassword>>, TError, { id: string }, TContext> => {
  return useMutation(getResetUserPasswordMutationOptions(options), queryClient);
};
export const getUpdateUserEmailUrl = (id: string) => {
  return `/users/${id}/email`;
};

/**
 * Updates the email address for a user. Only admins can perform this action.
 * @summary Update user email address
 */
export const updateUserEmail = async (id: string, updateEmail?: UpdateEmail, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getUpdateUserEmailUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateEmail),
  });
};

export const getUpdateUserEmailMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserEmail>>,
    TError,
    { id: string; data?: UpdateEmail },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserEmail>>,
  TError,
  { id: string; data?: UpdateEmail },
  TContext
> => {
  const mutationKey = ['updateUserEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserEmail>>,
    { id: string; data?: UpdateEmail }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserEmail(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserEmail>>>;
export type UpdateUserEmailMutationBody = UpdateEmail | undefined;
export type UpdateUserEmailMutationError = ApiError;

/**
 * @summary Update user email address
 */
export const useUpdateUserEmail = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserEmail>>,
      TError,
      { id: string; data?: UpdateEmail },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserEmail>>,
  TError,
  { id: string; data?: UpdateEmail },
  TContext
> => {
  return useMutation(getUpdateUserEmailMutationOptions(options), queryClient);
};
